import { render } from "./OfferBids.vue?vue&type=template&id=46335460"
import script from "./OfferBids.vue?vue&type=script&lang=js"
export * from "./OfferBids.vue?vue&type=script&lang=js"
script.render = render

export default script